import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Prospecto } from '../models/prospecto';

@Injectable({
  providedIn: 'root'
})
export class ProspectoService {

  constructor() { }
  private prospectoSub = new BehaviorSubject<Prospecto>(
    {
      nombre: '',
      edad: '',
      genero: '',
      habito: '',
      nombreMancomunado: '',
      edadMancomunado: '',
      generoMancomunado: '',
      habitoMancomunado: '',
      producto: '',
      plan:'',
      moneda: '',
      plazoPagos: 0,
      plazoSeguro: 0,
      valorUdi: 0,
      inflacion: 0,
      formaPago: '',
      primaAnual: 0,
      sumaAsegurada: 0,
      comision: '',
    }
  );

  /**
   * Envia el ultimo valor al stream del observable.
   * @param prospecto a setear.
   */
  public setProspecto(prospecto: Prospecto): void {
    this.prospectoSub.next(prospecto);
  }

  /**
   * Obtenemos el observable de los generales del prospecto.
   */
  public getProspecto(): Observable<Prospecto> {
    return this.prospectoSub.asObservable();
  }
}
